import React, {Component, Fragment} from 'react'
import {Button, Card, Col, Popover, Row, Drawer} from 'antd'
import OrgChart from 'react-orgchart'
import 'react-orgchart/index.css'
import {compose} from 'recompose'
import withLoadingSection from '../../elements/HOC/withLoadingSection'
import logo from '../../assets/img/logo_white.png'
import TeamListContainer from '../../components/People/TeamList/TeamListContainer'

class CompanyChart extends Component {
  state = {
    visible: false,
    node: '',
  }

  showDrawer = node => {
    this.setState({
      visible: true,
      node,
    })
  }

  onClose = () => {
    this.setState({
      visible: false,
      node: '',
    })
  }

  render() {
    const MyNodeComponent = ({node}) => {
      return (
        <Popover placement="bottom" content={node.actor}>
          <Button type={'dashed'} onClick={() => this.showDrawer(node.name)}>
            {node.name}
          </Button>
        </Popover>
      )
    }
    const {initechOrg} = this.props
    return (
      <Fragment>
        <Row style={{paddingTop: '10px'}}>
          <Card>
            <Row
              style={{
                marginBottom: '10px',
                paddingBottom: '10px',
                borderBottom: 'solid 1px rgb(217,217,217)',
              }}>
              <Col span={24} style={{textAlign: 'center'}}>
                <img
                  src={logo}
                  style={{marginTop: '0px', filter: 'invert(100%)'}}
                />
                <p
                  style={{
                    fontSize: '27pt',
                    fontWeight: 'bold',
                    marginTop: '20px',
                    marginBottom: '7px',
                  }}>
                  Organisation Chart
                </p>
              </Col>
            </Row>
            <Row id="initechOrgChart">
              <OrgChart tree={initechOrg} NodeComponent={MyNodeComponent} />
            </Row>
          </Card>
        </Row>
        <Drawer
          // title="Team List"
          placement="right"
          width={'500'}
          closable={false}
          onClose={this.onClose}
          visible={this.state.visible}>
          <TeamListContainer node={this.state.node} />
        </Drawer>
      </Fragment>
    )
  }
}

CompanyChart.defaultProps = {initechOrg: {}}

export default compose(withLoadingSection)(CompanyChart)
